/**
 * state - 类似于vue中data，用于存放数据模型；
 * getter - 类似于vue中computed，相当于state的计算属性；
 * mutation - 类似于vue中的method，只有它的方法函数可以改变state的值，同时它的方法函数必须是同步，不能是异步；
 * action - 类似mutation，但是它只能通过调用mutation来改变state的值，同时它的函数方法可以是异步的；
 * modules - 可以引入多个module，通过这个属性，我们可以添加多个module进入Vuex的store中。
 */

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// 多模块引入简写
let ms = require.context('./modules', false, /\.js$/)
let modules = {}
ms.keys().forEach(k => {
    let n = k.substring(2, k.length - 3) // './xxx.js'.substring(2, k.length - 3) =>  xxx 获取文件名
    modules[n] = ms(k).default
})


export default new Vuex.Store({
  modules
});
